// extracted by mini-css-extract-plugin
export default {"paragraphContainer":"hZ84i","paragraph":"v6LfC","bold":"VyeqU"};